import type { SlideEditTypeId } from "@/state/slideEditStore";

export const SLIDE_EDIT_TYPE_STEP_ORDER: SlideEditTypeId[] = [
  "chart-time-period-price-refresh",
  "chart-relative-benchmarks",
  "chart-customization-options",
  "text-on-slide",
];

export const SLIDE_EDIT_STEP_BAR_LABEL_BY_ID: Record<SlideEditTypeId, string> = {
  "chart-time-period-price-refresh": "Chart Time Period",
  "chart-relative-benchmarks": "Relative Benchmarks",
  "chart-customization-options": "Chart Customization Options",
  "text-on-slide": "Text on Slide",
};

export function getOrderedSelectedEditTypes(selected: SlideEditTypeId[]): SlideEditTypeId[] {
  const set = new Set(selected);
  return SLIDE_EDIT_TYPE_STEP_ORDER.filter((id) => set.has(id));
}

export function isSlideEditCustomizationStep(id: SlideEditTypeId): boolean {
  return id === "chart-customization-options";
}
